//// https://medium.com/@amanda.k.hussey/a-basic-tutorial-on-how-to-incorporate-speech-recognition-with-react-6dff9763cea5
//// https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognition
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";

import Loader from '../../Loader/Loader.jsx';
import TextToTextResponse from './TextToTextResponse.jsx';
import AuthButtons from "../../UI/AuthButtons.jsx";

import { useStore } from '../../../hook-store/store.js';

import { 
  ollamaNodeJsUrl,
} from "../../../App.js";

import './TextToText.css';



const TextToText = (props) => {
  const{
    textVoiceAssistantConfig,
  } = props;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  const { 
    isAuth,
    isOllamaMcpServer,
   } = store.uiStore;

  const [transcript, setTranscript] = useState("");
  // const [isListening, setIsListening] = useState(false);
  // const recognitionRef = useRef(null);

  const [responseText, setResponseText] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  let detectedLanguage = navigator.languages[0];
  const lsUserSelectLng = localStorage.getItem('userSelectLng');

  if (lsUserSelectLng) {
    detectedLanguage = lsUserSelectLng;
  }

  let maxLength = 200;

  if (textVoiceAssistantConfig && textVoiceAssistantConfig.maxLengthTextToText) {
    maxLength = textVoiceAssistantConfig.maxLengthTextToText;
  }


  const setTextInputHandler = (event) => {
    setTranscript(event.target.value);
  };

  const sendTextToTextHandler = async (text) => {
    try {
      setIsLoading(true);
      setErrorMessage('');

      // dispatch('SET_MLSPEECHISUSERGENERATING', true);
      // // throw new Error('error-error')

      const formData = new FormData();
      const sendText = text.slice(0, maxLength) + ' ?'
      // formData.append('fSttText', sendText);

      formData.append('textText', sendText);

      // console.log(text);
      // throw new Error('error-error')

      const url = ollamaNodeJsUrl + `/ollama-mcp-text-voice-assistant/post-text-voice-assistant`;
      const result = await fetch(url, {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        body: formData,
      });

      if (!result.ok) {
        throw new Error('error occured');
      }

      const resData = await result.json();
      console.log(result, resData);

      if (resData && resData.data && resData.data.llmResponse) {
        setResponseText(resData.data.llmResponse);
      }

      setIsLoading(false);

      dispatch('SHOW_NOTIFICATION', {
        status: '',
        title: 'Response updated',
        message: '',
      });

      setTimeout(() => {
        dispatch('CLEAR_NOTIFICATION');
      },1000 * 5);

    }
      catch(err) {
      console.log(err);
      setIsLoading(false);
      setErrorMessage('Response failed');
      
      // dispatch('SET_MLSPEECHISUSERGENERATING', false);
      // setTimeout(() => {
      //   dispatch('SET_MLSPEECHISUSERGENERATING', false);
      // },1000*20);
      
      throw err;
    }
  }

  let moreThanMaxLength = false;

  if (transcript.length > maxLength) {
    moreThanMaxLength = true;
  }


  return (
    <div className='textToText'
    // style={{border: "1px solid red"}}
    >
      <div className='textToTextRow'>
        <div>
          <label>
            {t("textVoiceAssistant01", "Text input")}
          </label>
        </div>
        <div>
          <textarea className='inputBase'
            type="text"
            value={transcript}
            placeholder='enter text to ask'
            onChange={setTextInputHandler}
          />
        </div>
        {transcript.length > 0 && textVoiceAssistantConfig &&  
          textVoiceAssistantConfig.maxLengthTextToText && (
          <div
            style={moreThanMaxLength ? {color: "red"} : null}
          >
            <span>
              ({transcript.length} / {textVoiceAssistantConfig.maxLengthTextToText})
            </span>
            {moreThanMaxLength && (
              <span>{' '}Text input should be less than {maxLength}</span>
            )}
          </div>
        )}
      </div>


      <div className='textToTextRow'>
        <button className='textToTextActionButton'
          disabled={isLoading || !transcript || !isAuth || moreThanMaxLength}
          onClick={() => {
            sendTextToTextHandler(transcript);
          }}
        >
          {t("textVoiceAssistant03", "Ask to assistant")}
        </button>
      </div>
        {isLoading && (
          <Loader />
        )}
        {errorMessage && (
          <div style={{color:"red"}}>
            {errorMessage}
          </div>
        )}
        {/* {!isOllamaMcpServer && (
          <div>busy...</div>
        )} */}

        {!isAuth && (
          <div>
            <div className='textToTextRow'>
              {t("textVoiceAssistant04", "Login is required.")}
            </div>
            <div className='textToTextRow'>
              <AuthButtons />
            </div>
          </div>
        )}

      <div>
        <TextToTextResponse
          responseText={responseText}
        />
      </div>


    </div>
  );
};

export default TextToText;